<template>
  <ScrollContainer v-if="!loading">
    <EditForm
      :user-data="user"
      :roles="roleItems"
      :entities="entities"
      :on-cancel="handleOnClose"
      :on-success="handleOnSuccess"
    />
  </ScrollContainer>
</template>

<script>
import ModalMixin from '@/General/Modal/ModalMixin.js'
import EditForm from '@/Modules/User/Components/EditForm.vue'
import UserModel from '@/Modules/User/UserModel.js'
import DatasetService from '@/Modules/Dataset/DatasetService.js'
import EntityService from '@/Modules/Entity/EntityService.js'
import ScrollContainer from '@/General/Modal/ScrollContainer.vue'

export default {
  name: 'EntityUserCreateModal',

  components: { EditForm, ScrollContainer },

  mixins: [ModalMixin],

  data() {
    return {
      loading: true,
      user: null,
      roleItems: [],
      entities: [],
    }
  },

  created() {
    this.$nextTick(() => this.errors.clear())

    this.loadAndSetData()
  },

  methods: {
    async loadAndSetData() {
      let userItem = new UserModel()

      await DatasetService.byTag('roles').then(
        (roles) => (this.roleItems = roles)
      )
      await DatasetService.byTag('entities').then(
        (entities) => (this.entities = entities)
      )

      EntityService.show(this.meta.entityId)
        .then((entity) => {
          if (_.isObject(entity)) {
            userItem.defaultEntityId = entity.id
            if (entity.addressCountry) {
              userItem.addressCountry = entity.addressCountry
            }
          }

          this.user = userItem
        })
        .catch((error) => {
          console.error('error', error)
        })
        .finally(() => (this.loading = false))
    },

    handleOnSuccess() {
      this.closeModal()
      this.onSuccess && this.onSuccess()
    },

    handleOnClose() {
      this.closeModal()
    },
  },
}
</script>
